import gameData from '../../gameData';
import Donut from './donutClass';
import { donutsIn, textIn } from './tweenTimelines';
import * as ABCya from '@abcya/abcya_phaser';
import sKey from '../../SoundAssetKeys';

export function displayDonuts(passedObject, scene)
{
    //star is widest donut, at 245
    const displayObj = passedObject.displayObj;
    const displayQtype = passedObject.type;
    const singleRow = (displayObj.length < 6) ? true : false;
    let donutX = [];
    let startY = (singleRow) ? [444] : [361,556];
    const leftTop = gameData.sizeMap.get(displayObj[0].shape) + gameData.sizeMap.get(displayObj[1].shape) + (gameData.sizeMap.get(displayObj[3].shape)/2);
    const rightTop = gameData.sizeMap.get(displayObj[3].shape) + gameData.sizeMap.get(displayObj[4].shape) + (gameData.sizeMap.get(displayObj[3].shape)/2);
    let leftBot, rightBot, leftRight, topBot;

    if(singleRow)
    {
        leftRight = leftTop - rightTop; //if left side donuts is larger this is a positive number
    }
    else
    {
        let position;
        let temp = 0;

        leftBot = gameData.sizeMap.get(displayObj[5].shape) + gameData.sizeMap.get(displayObj[6].shape) + (gameData.sizeMap.get(displayObj[7].shape)/2);
        rightBot = gameData.sizeMap.get(displayObj[8].shape) + gameData.sizeMap.get(displayObj[9].shape) + (gameData.sizeMap.get(displayObj[7].shape)/2);

        let sortArray = [leftTop, rightTop, leftBot, rightBot];

        for(let each in sortArray)
        {
            if(sortArray[each]>temp)
            {
                position = each;
                temp = sortArray[each];
            }
        }
        
        switch(position){
            case "0":
            case "1":
                topBot = "top";
                leftRight = leftTop - rightTop;
                break;
            case "2":
            case "3":
                topBot = "bot";
                leftRight = leftBot - rightBot;
                break;
        }
    }

    donutX = findAllDonutHorizontalPoints(displayObj,singleRow,leftRight,topBot);

    if(singleRow)
    {
        for(let each in displayObj)
        {
            gameData.currentDonuts.push(new Donut(donutX[each], startY[0], displayObj[each],scene,displayQtype));
        }
    }
    else
    {
        for(let each in displayObj)
        {
            if(each < 5)
            {
                gameData.currentDonuts.push(new Donut(donutX[each], startY[0], displayObj[each],scene,displayQtype));
            }
            else
            {
                gameData.currentDonuts.push(new Donut(donutX[each], startY[1], displayObj[each],scene,displayQtype));
            }
        }
    }

    donutsIn(scene);
    const textTween = textIn(scene,passedObject.question);

    textTween.on('complete',()=>{
        readQuestion(scene);
    })

    /**Used to find the gap between donuts to avoid overlap or overspacing
     * 
     * @param {object} displayObj List of donuts randomly choosen created by another function 
     * @param {boolean} singleRow If true only one row of donuts
     * @param {number} leftRight Width of first 2 donuts minus the last 2 donuts - used to determine which side is larger
     * @param {string} topBot "top" indicates larger top row "bot" indicates larger bottom row
     * @returns {array} Returns all points for the provided question
     */
    function findAllDonutHorizontalPoints(displayObj,singleRow,leftRight,topBot)
    {
        let largerSide = (leftRight > 0) ? "left" : "right";
        let first = 0;
        let second = 1;
        let third = 2;
        let xPoints = [];
        const spacingGap = 15;

        //Donuts are set up in two rows of five * * * * *
        //So if the right side is larger, the gaps between the last two stars is required
        //If left, the first two
    
        if(largerSide === "right")//This sets the focus of the equation to the last two
        {
            first += 3;
            second += 3;
        }
        if(topBot === "bot")//This sets the focus to the bottom row
        {
            first += 5;
            second += 5;
            third += 5;
        }

        //This equation finds the distance from the center donut, to the .5,.5 origin point of the furthest donut
        let gapLarge = gameData.sizeMap.get(displayObj[first].shape)/2 + spacingGap*2 + gameData.sizeMap.get(displayObj[second].shape) + (gameData.sizeMap.get(displayObj[third].shape)/2);
        let gapSmall = gapLarge/2;

        //Translate the distance to points

        xPoints[0] = 512 - gapLarge;
        xPoints[1] = 512 - gapSmall;
        xPoints[2] = 512;
        xPoints[3] = 512 + gapSmall;
        xPoints[4] = 512 + gapLarge;

        if(!singleRow)
        {
            xPoints = xPoints.concat(xPoints);//points are the same for both rows
        }

        return xPoints;
    }

    function readQuestion(scene)
    {
        switch(gameData.questionNum)
        {
            case 0:
                scene.custSound.playSoundCustom(sKey._same_shape_1);
                break;
            case 1:
                scene.custSound.playSoundCustom(sKey._same_shape_2);
                break;
            case 2:
                scene.custSound.playSoundCustom(sKey._different_shape1);
                break;
            case 3:
                scene.custSound.playSoundCustom(sKey._different_shape2);
                break;
            case 4:
                scene.custSound.playSoundCustom(sKey._same_color1);
                break;
            case 5:
                scene.custSound.playSoundCustom(sKey._same_color2);
                break;
            case 6:
                scene.custSound.playSoundCustom(sKey._different_color2);
                break;
            case 7:
                scene.custSound.playSoundCustom(sKey._different_color1);
                break;
            case 8:
                scene.custSound.playSoundCustom(sKey._same_shape_color1);
                break;
            case 9:
                scene.custSound.playSoundCustom(sKey._same_shape_color2);
                break;
            case 10:
                scene.custSound.playSoundCustom(sKey._different_shape_color1);
                break;
            case 11:
                scene.custSound.playSoundCustom(sKey._different_shape_color2);
                break;
        }
    }
}